  import React, { Component } from "react";
  import {
    Typography,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableBody,
    TableCell,
    TableContainer,
    TablePagination,
    Container, Grid, FormControl, InputBase,
    TextField,
    InputAdornment,
  } from "@material-ui/core";
  import { styled } from "@mui/material/styles";
  import { tableCellClasses } from "@mui/material/TableCell";
  import { SpinnerRoundFilled } from "spinners-react";
  import { formatDate } from "../../../../common/components/Helper/Utils";
  import { getDealerNotesList } from "../actions/dashboardAction";
  import DatePicker from "react-multi-date-picker";
  import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
  import DatePanel from "react-multi-date-picker/plugins/date_panel";
  import SearchIcon from "@mui/icons-material/Search";
  import ClearIcon from "@material-ui/icons/Clear";
  import IconButton from "@mui/material/IconButton";
  import moment from 'moment';
  import { getCustomLabel } from "../../../../common/components/Helper/Utils";

  const formatAuditMoney = (value) =>
    "$" +
    Number(value || 0).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const OTHER_INVENTORY_EDIT_FLAGS = [
    "is_note_edit",
    "is_public_dealer_note_edit",
    "is_tag_price_edit",
    "is_purchase_invoice_paid_edit",
    "is_purchase_payment_date_edit",
    "is_wholesale_price_edit",
    "is_retail_price_edit",
    "is_retailwire_price_edit",
    "is_purchase_expense_edit",
    "is_purchase_payment_details_edit",
  ];

  const hasOtherInventoryEdits = (eventChanges = {}) =>
    OTHER_INVENTORY_EDIT_FLAGS.some((flag) => eventChanges[flag]);

  const parseEventChanges = (raw) => {
    try {
      if (typeof raw === "string") {
        const trimmed = raw.trim();
        if (!trimmed) return {};
        if (trimmed.startsWith("{") || trimmed.startsWith("[")) {
          return JSON.parse(trimmed);
        }
        // Backend trade-payment logs store the full message string in purchaseprice
        if (/purchase price changed/i.test(trimmed)) {
          return {
            is_purchesd_price_edit: true,
            purchaseprice: trimmed,
          };
        }
        return {};
      }
      if (typeof raw === "object" && raw !== null) {
        const changes = { ...raw };
        if (
          !changes.is_purchesd_price_edit &&
          !hasOtherInventoryEdits(changes) &&
          (typeof changes.purchaseprice === "string" ||
            changes.from !== undefined ||
            changes.to !== undefined)
        ) {
          changes.is_purchesd_price_edit = true;
        }
        return changes;
      }
    } catch (e) {
      return {};
    }
    return {};
  };

  const toAuditPrice = (value) => {
    if (value === undefined || value === null || value === "") return null;
    // Prebuilt change messages must not be treated as numeric prices
    if (typeof value === "string" && /purchase price changed/i.test(value)) {
      return null;
    }
    const parsed = Number(String(value).replace(/[$,]/g, "").trim());
    return Number.isFinite(parsed) ? parsed : null;
  };

  const pricesAreEqual = (oldPrice, newPrice) => {
    if (oldPrice === null || newPrice === null) return false;
    return (
      Number(oldPrice) === Number(newPrice) ||
      formatAuditMoney(oldPrice) === formatAuditMoney(newPrice)
    );
  };

  const getPurchasePriceChangeValues = (
    eventrequest = {},
    eventChanges = {},
    { isInventoryCreate = false } = {}
  ) => {
    // Do NOT use payment old_amount — that is deposit/payment, not inventory purchase price
    const oldPrice = toAuditPrice(
      eventrequest.old_purchase_price ??
        eventrequest.old_purchaseprice ??
        eventChanges.from
    );

    const canUsePaymentAmountAsPrice =
      isInventoryCreate ||
      (eventChanges.is_purchesd_price_edit && !hasOtherInventoryEdits(eventChanges));

    // Trade payment logs may only store the applied payment as amount/deposit
    const newPrice = toAuditPrice(
      eventrequest.purchase_price ??
        eventrequest.purchaseprice ??
        eventChanges.to ??
        (canUsePaymentAmountAsPrice
          ? eventrequest.amount ?? eventrequest.deposit
          : null)
    );

    // Prefer prebuilt message from backend when numeric fields are missing
    const message =
      typeof eventChanges.purchaseprice === "string"
        ? eventChanges.purchaseprice
        : typeof eventrequest.purchaseprice === "string" &&
          /purchase price changed/i.test(eventrequest.purchaseprice)
        ? eventrequest.purchaseprice
        : null;

    return {
      oldPrice,
      newPrice,
      message,
    };
  };
  const shouldShowPurchasePrice = (
    isInventoryCreate,
    eventChanges,
    purchasePriceChange
  ) => {
    const { oldPrice, newPrice, message } = purchasePriceChange;
    if (isInventoryCreate) {
      return newPrice !== null || oldPrice !== null || !!message;
    }
    if (pricesAreEqual(oldPrice, newPrice)) return false;
    if (eventChanges.is_purchesd_price_edit) {
      return oldPrice !== null || newPrice !== null || !!message;
    }
    if (hasOtherInventoryEdits(eventChanges)) return false;
    if (message) return true;
    return oldPrice !== null && newPrice !== null && Number(oldPrice) !== Number(newPrice);
  };
  const columns = [
    { id: "Team", label: "Team Member", minWidth: 100 },
    { id: "date", label: "Date", minWidth: 100 },
    { id: "event", label: "Event", minWidth: 100 },
  ];

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  class InventoryAuditLogsComponent extends Component {
    constructor(props) {
      super(props);
      this.state = {
        page: 0,
        rowsPerPage: 10,
        data: [],
        loader: true,
        searchKeyword: "",
        accountId: "",
        shippingDateValue: [],
        inventoryId: "Inventory ID",
        invoiceId: "Invoice ID",
        auditLogs: null,
        accountIds: window.sessionStorage.getItem("accountId"),
      };
    }

    componentDidMount() {
      this.fetchAuditLogs();
    }

    componentDidUpdate(prevProps) {
      if (prevProps.inventoryId !== this.props.inventoryId) {
        this.fetchAuditLogs();
      }
    }

    fetchAuditLogs = async (overrideKeyword = null) => {
      if (!this.props.inventoryId) return;
    this.setState({ loader: true });

    const keyword = overrideKeyword !== null ? overrideKeyword : this.state.searchKeyword;

    const dashboardData = {
      id: Number(this.props.inventoryId),
      accountId: this.props.accountId || this.state.accountIds,
      name: keyword.trim(),
    };

    if (
      this.state.shippingDateValue &&
      this.state.shippingDateValue.length === 2 &&
      this.state.shippingDateValue[0] &&
      this.state.shippingDateValue[1]
    ) {
      dashboardData.auditDateInterval = {
        from: this.state.shippingDateValue[0].format("YYYY-MM-DD"),
        to: this.state.shippingDateValue[1].format("YYYY-MM-DD"),
      };
    }

    try {
      const result = await getDealerNotesList(dashboardData);
      this.setState({ data: result?.data || [] });
    } catch (error) {
      this.setState({ data: [] });
    } finally {
      this.setState({ loader: false });
    }
  };

    handleChangePage = (event, newPage) => {
      this.setState({ page: newPage });
    };

    handleChangeRowsPerPage = (event) => {
      this.setState({
        rowsPerPage: +event.target.value,
        page: 0,
      });
    };

    handleClearButton = () => {
      this.setState({ searchKeyword: ""}, () => {
        this.fetchAuditLogs(""); 
      });
    };

    handleMouseDown = (event) => {
      event.preventDefault();
    };

    onSearchClick = (e) => {
      this.setState({ searchKeyword: e.target.value });
    };

    handleEnterEvent = (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        this.fetchAuditLogs(this.state.searchKeyword);
      }
    };

    endAdornment = () => {
      if (this.state.searchKeyword) {
        return (
          <InputAdornment position="end">
            <IconButton
              onClick={this.handleClearButton}
              onMouseDown={this.handleMouseDown}
              color="primary"
            >
              <ClearIcon />
            </IconButton>
            <IconButton
              className="primary-bg color-white"
              type="button"
              sx={{ p: "10px" }}
              aria-label="search"
              onClick={() => this.fetchAuditLogs(this.state.searchKeyword)}
            >
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        );
      } else {
        return (
          <InputAdornment position="end">
            <IconButton
              className="primary-bg color-white"
              type="button"
              sx={{ p: "10px" }}
              aria-label="search"
              onClick={() => this.fetchAuditLogs("")}
            >
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        );
      }
    };

    CustomInput = ({ onFocus, value, onChange }) => {
      return (
        <TextField
          id="outlined-basic"
          label="Audit Date"
          style={{ width: "100%" }}
          variant="outlined"
          onFocus={onFocus}
          placeholder="from YYYY/MM/DD to YYYY/MM/DD"
          onPaste={(event) => event.preventDefault()}
          value={value}
          onChange={onChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <CalendarMonthIcon />
              </InputAdornment>
            ),
          }}
        />
      );
    };

    render() {
      const { page, rowsPerPage, data, loader, searchKeyword, shippingDateValue } = this.state;

      return (
          <div className="space-bottom-30 someextrahight">
              <Container>
                  <Grid container spacing={3}>
                      <Grid item xs={12}>
                          <Typography variant="h6">
                              <b>Audit Logs</b>
                          </Typography>
                      </Grid>
                      <Grid item xs={12} md={6}>
                          <DatePicker
                              range
                              render={<this.CustomInput />}
                              value={shippingDateValue}
                              containerStyle={{ display: "block" }}
                                onChange={(dateObjects) => {
                                this.setState({ shippingDateValue: dateObjects }, () => {
                                  if (
                                    Array.isArray(this.state.shippingDateValue) &&
                                    this.state.shippingDateValue.length === 2 &&
                                    this.state.shippingDateValue[0] &&
                                    this.state.shippingDateValue[1]
                                  ) {
                                    this.fetchAuditLogs(this.state.searchKeyword);
                                  }
                                  if (
                                    Array.isArray(this.state.shippingDateValue) &&
                                    this.state.shippingDateValue.length === 0
                                  ) {
                                  this.fetchAuditLogs(this.state.searchKeyword);
                                  }
                                });
                              }}
                              rangeHover
                              dateSeparator=" to "
                              plugins={[<DatePanel />]}
                          />
                      </Grid>
                      <Grid item xs={12} md={6}>
                          <FormControl className="form-width-100">
                              <div style={{ marginLeft: "5px" }}>
                                  <Paper
                                      component="form"
                                      sx={{ p: "2px 0px" }}
                                      style={{ height: "55px", display: "flex", width: "100%" }}
                                  >
                                      <InputBase
                                          fullWidth
                                          placeholder="Search by Name / Email"
                                          style={{
                                              flex: 1,
                                              marginLeft: "20px",
                                              marginRight: "10px",
                                          }}
                                          inputProps={{
                                              "aria-label": "Search by Name / Email",
                                          }}
                                          onChange={(e) => {
                                              this.onSearchClick(e);
                                          }}
                                          onKeyPress={this.handleEnterEvent}
                                          value={searchKeyword}
                                          endAdornment={this.endAdornment()}
                                      />
                                  </Paper>
                              </div>
                          </FormControl>
                      </Grid>
                      {loader ? (
                          <div className="d-spinner">
                              <SpinnerRoundFilled
                                  size={51}
                                  thickness={125}
                                  speed={80}
                                  color="rgba(57, 107, 172, 1)"
                                  className="spp"
                                  enabled={loader}
                              />
                          </div>
                      ) : (
                          <Grid item xs={12}>
                              <Paper style={{ width: "100%", overflow: "hidden" }}>
                                  <TableContainer>
                                      <Table aria-label="sticky table">
                                          <TableHead>
                                              <TableRow>
                                                  {columns.map((column) => (
                                                      <StyledTableCell key={column.id} align={column.align}>
                                                          {column.label}
                                                      </StyledTableCell>
                                                  ))}
                                              </TableRow>
                                          </TableHead>
                                         <TableBody>
                                            {data && data.length ? (
                                              data
                                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                .map((row, index) => {
                                                let eventChanges = parseEventChanges(
                                                  row.eventrequest?.eventrequestchanged
                                                );
                                                  //  const isAddEvent = row.events === "Add New Watch in Inventory";
                                                  const isInventoryCreate =
                                                  row.eventtype === "Inventory Create" ||
                                                  row.eventrequest?.eventtype === "Inventory Create";
                                                  const purchasePriceChange = getPurchasePriceChangeValues(
                                                    row.eventrequest,
                                                    eventChanges,
                                                    { isInventoryCreate }
                                                  );
                                                  const hasPurchasePriceEdit = shouldShowPurchasePrice(
                                                    isInventoryCreate,
                                                    eventChanges,
                                                    purchasePriceChange
                                                  );
                                                    const showRow = 
                                                      isInventoryCreate ||
                                                      eventChanges.is_note_edit ||
                                                      eventChanges.is_public_dealer_note_edit ||
                                                      eventChanges.is_tag_price_edit ||
                                                      eventChanges.is_purchase_invoice_paid_edit ||
                                                      eventChanges.is_purchase_payment_date_edit ||
                                                      eventChanges.is_wholesale_price_edit ||
                                                      eventChanges.is_retail_price_edit ||
                                                      eventChanges.is_retailwire_price_edit ||
                                                      hasPurchasePriceEdit ||
                                                      eventChanges.is_purchase_expense_edit ||
                                                      eventChanges.is_purchase_payment_details_edit;

                                                    if (!showRow) return null; 
                                                  // if (!Object.values(eventChanges).some(v => v === true)) return null;

                                                  return (
                                                    <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                                                      <StyledTableCell>
                                                        <b>{row.eventdata?.firstname} {row.eventdata?.lastname}</b>
                                                        <br />
                                                        {row.eventdata?.email}
                                                      </StyledTableCell>
                                                     <StyledTableCell>
                                                      {row.createdon ? formatDate(new Date(row.createdon).toLocaleString(),
                                                        "MM/DD/YYYY hh:mm:ss"
                                                        ): ""}
                                                     </StyledTableCell>
                                                      <StyledTableCell>
                                                        <b>{row.events}</b><br />

                                                        {eventChanges.is_public_dealer_note_edit ? (
                                                          <>
                                                            <b>Edited Public Dealer Note:</b> {row.eventrequest.public_dealer_note || "-"} <br />
                                                          </>
                                                        ) : null}

                                                        {eventChanges.is_note_edit ? (
                                                          <>
                                                            <b>Edited Private Dealer Note:</b> {row.eventrequest.note || "-"} <br />
                                                          </>
                                                        ) : null}

                                                        {eventChanges.is_tag_price_edit ? (
                                                          <>
                                                            <b>{getCustomLabel("custom_tag_price", "Tag Price")} changed from:</b>{" "}
                                                            {"$" + parseFloat(row.eventrequest.old_tag_price  || 0).toLocaleString(undefined, { 
                                                              minimumFractionDigits: 2, 
                                                              maximumFractionDigits: 2 
                                                            })}{" "}
                                                            <b>to</b>{" "}
                                                            {"$" + parseFloat(row.eventrequest.tag_price || 0).toLocaleString(undefined, { 
                                                              minimumFractionDigits: 2, 
                                                              maximumFractionDigits: 2 
                                                            })}
                                                            <br />
                                                          </>
                                                        ) : null}

                                                        {eventChanges.is_wholesale_price_edit ? (
                                                          <>
                                                            <b>{getCustomLabel("custom_wholesale_price", "Target Wholesale Price")} changed from:</b>{" "}
                                                            {"$" + parseFloat(row.eventrequest.old_wholesale_price  || 0).toLocaleString(undefined, { 
                                                              minimumFractionDigits: 2, 
                                                              maximumFractionDigits: 2 
                                                            })}{" "}
                                                            <b>to</b>{" "}
                                                            {"$" + parseFloat(row.eventrequest.wholesale_price || 0).toLocaleString(undefined, { 
                                                              minimumFractionDigits: 2, 
                                                              maximumFractionDigits: 2 
                                                            })}
                                                            <br />
                                                          </>
                                                        ) : null}

                                                        {eventChanges.is_retail_price_edit ? (
                                                          <>
                                                            <b>{getCustomLabel("custom_end_customer_price", "Target End Customer Price")} changed from:</b>{" "}
                                                            {"$" + parseFloat(row.eventrequest.old_retail_price || 0).toLocaleString(undefined, { 
                                                              minimumFractionDigits: 2, 
                                                              maximumFractionDigits: 2 
                                                            })}{" "}
                                                            <b>to</b>{" "}
                                                            {"$" + parseFloat(row.eventrequest.retail_price || 0).toLocaleString(undefined, { 
                                                              minimumFractionDigits: 2, 
                                                              maximumFractionDigits: 2 
                                                            })}
                                                            <br />
                                                          </>
                                                        ) : null}

                                                        {eventChanges.is_retailwire_price_edit ? (
                                                          <>
                                                            <b>{getCustomLabel("custom_end_customer_wire_price", "Target End Customer Wire Price")} changed from:</b>{" "}
                                                            {"$" + parseFloat(row.eventrequest.old_retailwire_price || 0).toLocaleString(undefined, { 
                                                              minimumFractionDigits: 2, 
                                                              maximumFractionDigits: 2 
                                                            })}{" "}
                                                            <b>to</b>{" "}
                                                            {"$" + parseFloat(row.eventrequest.retailwire_price || 0).toLocaleString(undefined, { 
                                                              minimumFractionDigits: 2, 
                                                              maximumFractionDigits: 2 
                                                            })}
                                                            <br />
                                                          </>
                                                        ) : null}

                                                        {hasPurchasePriceEdit ? (
                                                          <>
                                                            {purchasePriceChange.message &&
                                                            purchasePriceChange.oldPrice === null &&
                                                            purchasePriceChange.newPrice === null ? (
                                                              <>
                                                                {purchasePriceChange.message}
                                                                <br />
                                                              </>
                                                            ) : isInventoryCreate &&
                                                              (purchasePriceChange.newPrice !== null ||
                                                                purchasePriceChange.oldPrice !== null) ? (
                                                              <>
                                                                <b>Purchase price set to:</b>{" "}
                                                                {formatAuditMoney(
                                                                  purchasePriceChange.newPrice ??
                                                                    purchasePriceChange.oldPrice
                                                                )}
                                                                <br />
                                                              </>
                                                            ) : purchasePriceChange.oldPrice !== null &&
                                                              purchasePriceChange.newPrice !== null ? (
                                                          <>
                                                            <b>Purchase price changed from:</b>{" "}
                                                                {formatAuditMoney(
                                                                  purchasePriceChange.oldPrice
                                                                )}{" "}
                                                            <b>to</b>{" "}
                                                                {formatAuditMoney(
                                                                  purchasePriceChange.newPrice
                                                                )}
                                                                <br />
                                                              </>
                                                            ) : purchasePriceChange.newPrice !== null ? (
                                                              <>
                                                                <b>Purchase price set to:</b>{" "}
                                                                {formatAuditMoney(
                                                                  purchasePriceChange.newPrice
                                                                )}
                                                                <br />
                                                              </>
                                                            ) : purchasePriceChange.oldPrice !== null ? (
                                                              <>
                                                                <b>Purchase price changed from:</b>{" "}
                                                                {formatAuditMoney(
                                                                  purchasePriceChange.oldPrice
                                                                )}
                                                            <br />
                                                              </>
                                                            ) : null}
                                                          </>
                                                        ) : null}

                                                        {eventChanges.is_purchase_expense_edit ? (
                                                          <>
                                                            <b>Purchase Expense changed from:</b>{" "}
                                                            {"$" + parseFloat(row.eventrequest.old_purchase_expense  || 0).toLocaleString(undefined, { 
                                                              minimumFractionDigits: 2, 
                                                              maximumFractionDigits: 2 
                                                            })}{" "}
                                                            <b>to</b>{" "}
                                                            {"$" + parseFloat(row.eventrequest.purchase_expense || 0).toLocaleString(undefined, { 
                                                              minimumFractionDigits: 2, 
                                                              maximumFractionDigits: 2 
                                                            })}
                                                            <br />
                                                          </>
                                                        ) : null}

                                                        {eventChanges.is_purchase_invoice_paid_edit ? (
                                                          <>
                                                            <b>Purchase Payment Status changed to:</b>{" "}
                                                            {(row.eventrequest.purchase_invoice_paid === true ||
                                                              row.eventrequest.purchase_invoice_paid === "true" ||
                                                              row.eventrequest.purchase_invoice_paid === 1 || row.eventrequest.purchase_invoice_paid === "1")
                                                              ? "Paid"
                                                              : "Not Paid"}
                                                            <br />
                                                          </>
                                                        ) : null}

                                                        {eventChanges.is_purchase_payment_date_edit ? (
                                                          <>
                                                            <b>Purchase Payment date changed to:</b>{" "}
                                                            {row.eventrequest.purchase_payment_date || "-"} <br />
                                                          </>
                                                        ) : null}

                                                        {eventChanges.is_purchase_payment_details_edit ? (
                                                          <>
                                                            <b>Purchase payment details added:</b>{" "}
                                                            {row.eventrequest.purchase_payment_details || "-"} <br />
                                                          </>
                                                        ) : null}
                                                      </StyledTableCell>
                                                    </TableRow>
                                                  );
                                                })
                                                .filter(row => row !== null)
                                            ) : (
                                              <TableRow>
                                                <TableCell colSpan={3} align="center">
                                                  <Typography variant="h6" className="color-BCBCBC">
                                                    No Records Found
                                                  </Typography>
                                                </TableCell>
                                              </TableRow>
                                            )}
                                          </TableBody>
                                      </Table>
                                  </TableContainer>
                                  <TablePagination
                                      rowsPerPageOptions={[10, 25, 100]}
                                      component="div"
                                      count={data.length || 0}
                                      SelectProps={{
                                          native: true,
                                      }}
                                      rowsPerPage={rowsPerPage}
                                      page={page}
                                      onPageChange={this.handleChangePage}
                                      onRowsPerPageChange={this.handleChangeRowsPerPage}
                                  />
                              </Paper>
                          </Grid>
                      )}
                  </Grid>
              </Container>
          </div>
      );
  };
  }

  export default InventoryAuditLogsComponent;